const Feeds = () => {
  return <div>Feeds</div>;
};
export default Feeds;
